/* Yambillo thema-scripts: winkelwagen (Shopify AJAX Cart API), lades, verlanglijstje,
   leverdatum, welkomstkorting, productpagina, bundelbouwer en kleine animaties. */
(function () {
  "use strict";
  var CFG = window.YB_CFG || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem("yb-" + k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem("yb-" + k, JSON.stringify(v)); } catch (e) {} }
  };
  function money(cents) {
    var fmt = CFG.moneyFormat || "€{{amount_with_comma_separator}}";
    var n = (cents / 100).toFixed(2);
    var comma = n.replace(".", ",");
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === "amount_with_comma_separator") return comma;
      if (key === "amount_no_decimals") return Math.round(cents / 100);
      if (key === "amount_no_decimals_with_comma_separator") return Math.round(cents / 100);
      return n;
    }).replace(/<[^>]+>/g, "");
  }
  window.YB = window.YB || {};
  window.YB.money = money;

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $("#yb-toast"); if (!t) return;
    t.textContent = msg; t.dataset.show = "true";
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.dataset.show = "false"; }, 2400);
  }
  window.YB.toast = toast;

  /* ---------- Lades ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement; d.dataset.open = "true"; d.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    var f = d.querySelector(".yb-drawer__head button, a, input, select"); if (f) f.focus();
  }
  function closeDrawer(d) {
    if (!d) return;
    d.dataset.open = "false"; d.setAttribute("aria-hidden", "true"); document.body.style.overflow = "";
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  window.YB.openDrawer = openDrawer;

  /* ---------- Winkelwagen ---------- */
  var SECTIONS = ["yb-cart-drawer"];
  function cartSections() {
    var s = SECTIONS.slice();
    var main = $("[data-cart-section]"); if (main) s.push(main.dataset.cartSection);
    return s;
  }
  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id]; if (!html) return;
      var holder = document.getElementById("shopify-section-" + id);
      if (!holder) return;
      var wasOpen = id === "yb-cart-drawer" && $("#yb-cart") && $("#yb-cart").dataset.open === "true";
      holder.outerHTML = html;
      if (wasOpen) { var d = $("#yb-cart"); d.dataset.open = "true"; d.setAttribute("aria-hidden", "false"); }
    });
    var dr = $("#yb-cart");
    if (dr) $$("[data-cart-count]").forEach(function (el) { el.textContent = dr.dataset.count; el.hidden = +dr.dataset.count === 0; });
    document.dispatchEvent(new CustomEvent("yb:cart-updated"));
  }
  function post(url, body) {
    return fetch(url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function addItems(items, opts) {
    opts = opts || {};
    return post((CFG.routes && CFG.routes.add || "/cart/add") + ".js", { items: items, sections: cartSections().join(",") })
      .then(function (res) {
        applySections(res.sections);
        if (!document.body.hasAttribute("data-no-drawer") && !opts.silent) openDrawer("yb-cart");
        toast(opts.msg || "Toegevoegd aan je winkelwagen");
        return res;
      })
      .catch(function (err) { toast((err && err.description) || "Dit product kon niet worden toegevoegd."); throw err; });
  }
  function changeLine(key, qty) {
    return post((CFG.routes && CFG.routes.change || "/cart/change") + ".js", { id: key, quantity: qty, sections: cartSections().join(",") })
      .then(function (res) { applySections(res.sections); return res; })
      .catch(function (err) { toast((err && err.description) || "Aanpassen lukte niet."); });
  }
  window.YB.addItems = addItems; window.YB.changeLine = changeLine;

  /* ---------- Verlanglijstje (in deze browser) ---------- */
  function wishList() { return store.get("wish", []); }
  function renderWishState() {
    var w = wishList();
    $$("[data-wish]").forEach(function (b) { b.setAttribute("aria-pressed", w.indexOf(b.dataset.wish) > -1); });
    $$("[data-wish-count]").forEach(function (el) { el.textContent = w.length; el.hidden = !w.length; });
  }

  /* ---------- Leverdatum ---------- */
  function deliveryText() {
    var now = new Date(), d = new Date(now), cut = CFG.cutoff || 16;
    var before = now.getHours() < cut && now.getDay() !== 0 && now.getDay() !== 6;
    var add = before ? 1 : 2;
    if (now.getDay() === 5 && !before) add = 4;
    if (now.getDay() === 6) add = 3;
    if (now.getDay() === 0) add = 2;
    d.setDate(d.getDate() + add);
    if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    var day = d.toLocaleDateString("nl-NL", { weekday: "long", day: "numeric", month: "long" });
    var mins = before ? (cut * 60) - (now.getHours() * 60 + now.getMinutes()) : 0;
    var lead = before ? "Bestel binnen " + Math.floor(mins / 60) + " uur en " + (mins % 60) + " min, " : "Bestel vandaag, ";
    return lead + "dan is het <strong>" + day + "</strong> in huis.";
  }

  /* ---------- Klikken ---------- */
  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-add],[data-wish],[data-opens],[data-close],[data-remove],[data-qty-line]");
    if (!t) return;
    if (t.dataset.add) {
      e.preventDefault();
      t.disabled = true;
      addItems([{ id: +t.dataset.add, quantity: 1 }]).finally(function () { t.disabled = false; });
    }
    if (t.dataset.wish) {
      e.preventDefault();
      var w = wishList(), i = w.indexOf(t.dataset.wish);
      if (i > -1) w.splice(i, 1); else w.push(t.dataset.wish);
      store.set("wish", w); renderWishState();
      toast(i > -1 ? "Verwijderd van je verlanglijstje" : "Op je verlanglijstje gezet");
    }
    if (t.dataset.opens) {
      if (t.dataset.opens === "yb-cart" && document.body.hasAttribute("data-no-drawer")) return;
      e.preventDefault(); openDrawer(t.dataset.opens);
    }
    if (t.dataset.close !== undefined) closeDrawer(t.closest(".yb-drawer"));
    if (t.dataset.remove) { e.preventDefault(); changeLine(t.dataset.remove, 0); }
    if (t.dataset.qtyLine) {
      e.preventDefault();
      var q = Math.max(0, (+t.dataset.current || 0) + (+t.dataset.step || 0));
      changeLine(t.dataset.qtyLine, q);
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { var d = $('.yb-drawer[data-open="true"]'); if (d) closeDrawer(d); }
  });

  /* ---------- Formulieren "in winkelwagen" zonder herladen ---------- */
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (!f.matches || !f.matches("form[data-yb-product-form]")) return;
    e.preventDefault();
    var id = +f.querySelector('[name="id"]').value, qty = +(f.querySelector('[name="quantity"]') || { value: 1 }).value || 1;
    var btn = f.querySelector('[type="submit"]'); if (btn) btn.disabled = true;
    addItems([{ id: id, quantity: qty }]).finally(function () { if (btn) btn.disabled = false; });
  });

  /* ---------- Init ---------- */
  document.addEventListener("DOMContentLoaded", function () {
    renderWishState();
    $$("[data-delivery]").forEach(function (el) { el.innerHTML = deliveryText(); });
  });
  document.addEventListener("yb:cart-updated", renderWishState);
})();

/* ---------- Welkomstkorting (sticky knop + pop-up) ----------
   Timer alleen voor de echte geldigheid na aanmelding. Aanmelden = nieuwsbrief via het Shopify-klantformulier. */
(function () {
  "use strict";
  var C = (window.YB_CFG && window.YB_CFG.offer) || {};
  if (!C.on) return;
  var $ = function (s) { return document.querySelector(s); };
  var get = function (k, d) { try { var v = localStorage.getItem("yb-" + k); return v ? JSON.parse(v) : d; } catch (e) { return d; } };
  var set = function (k, v) { try { localStorage.setItem("yb-" + k, JSON.stringify(v)); } catch (e) {} };
  var sget = function (k) { try { return sessionStorage.getItem("yb-" + k); } catch (e) { return null; } };
  var sset = function (k) { try { sessionStorage.setItem("yb-" + k, "1"); } catch (e) {} };
  var HOURS = +C.hours || 0, DISMISS_DAYS = 7;
  function claim() { return get("offer", null); }
  function msLeft() { var c = claim(); if (!c) return 0; return HOURS ? c.claimedAt + HOURS * 3600e3 - Date.now() : Infinity; }
  function fmt(ms) {
    var s = Math.max(0, Math.floor(ms / 1000)), h = Math.floor(s / 3600), m = Math.floor(s % 3600 / 60), x = s % 60;
    var p = function (n) { return (n < 10 ? "0" : "") + n; };
    return p(h) + ":" + p(m) + ":" + p(x);
  }
  var lastFocus = null;
  function renderBtn() {
    var btn = $("#yb-offer-btn"), x = $("#yb-offer-x"), txt = $("#yb-offer-btn-text"); if (!btn) return;
    var c = claim();
    if (c && msLeft() <= 0) { btn.hidden = true; x.hidden = true; return; }
    if (c) {
      var hid = get("offer-btn-hidden", false);
      btn.hidden = hid; btn.dataset.state = "claimed";
      x.hidden = HOURS ? true : hid;
      txt.innerHTML = HOURS ? "<strong>Code " + C.code + "</strong><small>Nog <span class=\"yb-offer-btn__time\">" + fmt(msLeft()) + "</span> geldig</small>" : "<strong>Code " + C.code + "</strong><small>Vul in bij afrekenen</small>";
      return;
    }
    var hidden = get("offer-btn-hidden", false);
    btn.hidden = hidden; x.hidden = hidden; btn.dataset.state = "open";
    txt.innerHTML = "<strong>" + C.pct + "% welkomstkorting</strong><small>Op je eerste bestelling</small>";
  }
  function tick() { renderBtn(); var cd = document.querySelector("[data-offer-countdown]"); if (cd && HOURS) cd.textContent = fmt(msLeft()); }
  function open(auto) {
    var m = $("#yb-offer"); if (!m || m.dataset.open === "true") return;
    if (document.querySelector('.yb-drawer[data-open="true"]')) return;
    lastFocus = document.activeElement;
    var c = claim();
    $("#yb-offer-step1").hidden = !!c; $("#yb-offer-step2").hidden = !c;
    m.dataset.open = "true"; m.setAttribute("aria-hidden", "false"); document.body.style.overflow = "hidden";
    if (auto) sset("offer-shown");
    setTimeout(function () { var f = c ? $("#yb-offer-done") : $("#yb-offer-email"); if (f) f.focus(); }, 30);
  }
  function close() {
    var m = $("#yb-offer"); if (!m || m.dataset.open !== "true") return;
    m.dataset.open = "false"; m.setAttribute("aria-hidden", "true"); document.body.style.overflow = "";
    if (!claim()) set("offer-dismissed", Date.now());
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function canAuto() {
    if (claim() || sget("offer-shown")) return false;
    var d = get("offer-dismissed", 0);
    return !d || Date.now() - d > DISMISS_DAYS * 864e5;
  }
  document.addEventListener("DOMContentLoaded", function () {
    var m = $("#yb-offer"); if (!m) return;
    if (document.querySelector("[data-offer-success]") && !claim()) { set("offer", { claimedAt: Date.now() }); open(false); }
    else if (document.querySelector("[data-offer-error]")) open(false);
    tick(); if (HOURS) setInterval(tick, 1000);
    $("#yb-offer-btn").addEventListener("click", function () { open(false); });
    $("#yb-offer-x").addEventListener("click", function () { set("offer-btn-hidden", true); renderBtn(); });
    document.addEventListener("click", function (e) { if (e.target.closest("[data-offer-close]")) close(); });
    document.addEventListener("keydown", function (e) {
      if (m.dataset.open !== "true") return;
      if (e.key === "Escape") { close(); return; }
      if (e.key === "Tab") {
        var f = Array.prototype.filter.call(m.querySelectorAll("button, a, input"), function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    var form = $("#yb-offer-form");
    if (form) form.addEventListener("submit", function (e) {
      var inp = $("#yb-offer-email"), err = $("#yb-offer-err"), v = inp.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
        e.preventDefault();
        err.hidden = false; err.textContent = "Vul een geldig e-mailadres in, bijvoorbeeld naam@voorbeeld.nl.";
        inp.setAttribute("aria-invalid", "true"); inp.focus();
      }
    });
    var copy = $("#yb-offer-copy");
    if (copy) copy.addEventListener("click", function () {
      var done = function () { if (window.YB && YB.toast) YB.toast("Code gekopieerd"); copy.textContent = "Gekopieerd!"; setTimeout(function () { copy.textContent = "Kopieer mijn code"; }, 2000); };
      try { navigator.clipboard.writeText(C.code).then(done); } catch (x) {}
    });
    if (canAuto()) {
      var fired = false, fire = function () { if (!fired && canAuto()) { fired = true; open(true); } };
      setTimeout(fire, C.delay || 15000);
      window.addEventListener("scroll", function () {
        var h = document.documentElement; if ((h.scrollTop + innerHeight) / h.scrollHeight > 0.5) fire();
      }, { passive: true });
      document.addEventListener("mouseout", function (e) { if (!e.relatedTarget && e.clientY <= 0) fire(); });
    }
    var hero = document.querySelector(".yb-hero"), btn = $("#yb-offer-btn"), x = $("#yb-offer-x");
    if (hero && "IntersectionObserver" in window) {
      var tuck = function (on) { [btn, x].forEach(function (el) { if (el) { el.classList.toggle("is-tucked", on); el.tabIndex = on ? -1 : 0; } }); };
      tuck(true);
      new IntersectionObserver(function (en) { tuck(en[0].intersectionRatio > 0.35); }, { threshold: [0, 0.35, 1] }).observe(hero);
    }
  });
})();

/* ---------- Micro-interacties en accordeons ---------- */
(function () {
  "use strict";
  var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  function animateDetails(d) {
    var sum = d.querySelector("summary"); if (!sum) return;
    sum.addEventListener("click", function (e) {
      if (reduce || !d.animate) return;
      e.preventDefault();
      if (d.dataset.anim) return;
      var start = d.offsetHeight, end;
      if (d.open) {
        end = sum.offsetHeight + (parseFloat(getComputedStyle(d).borderTopWidth) * 2 || 0);
        d.dataset.anim = "1";
        var a = d.animate({ height: [start + "px", end + "px"] }, { duration: 260, easing: "cubic-bezier(.2,.8,.2,1)" });
        a.onfinish = function () { d.open = false; delete d.dataset.anim; };
      } else {
        d.open = true; end = d.offsetHeight; d.dataset.anim = "1";
        var b = d.animate({ height: [start + "px", end + "px"] }, { duration: 300, easing: "cubic-bezier(.2,.8,.2,1)" });
        b.onfinish = function () { delete d.dataset.anim; };
      }
    });
  }
  document.addEventListener("click", function (e) {
    var add = e.target.closest("button.yb-add");
    if (add) {
      if (!add.dataset.icon) add.dataset.icon = add.innerHTML;
      add.innerHTML = CHECK; add.classList.add("is-added");
      clearTimeout(add._t); add._t = setTimeout(function () { add.innerHTML = add.dataset.icon; add.classList.remove("is-added"); }, 1300);
    }
    var wish = e.target.closest(".yb-wish");
    if (wish) { wish.classList.remove("is-pop"); void wish.offsetWidth; wish.classList.add("is-pop"); }
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (a) { var d = document.getElementById(a.getAttribute("href").slice(1)); if (d && d.tagName === "DETAILS") d.open = true; }
  });
  document.addEventListener("DOMContentLoaded", function () {
    Array.prototype.forEach.call(document.querySelectorAll(".yb-faq details, .yb-acc details"), animateDetails);
    var h = location.hash && document.getElementById(location.hash.slice(1));
    if (h && h.tagName === "DETAILS") h.open = true;
  });
})();

/* ---------- Horizontale sliders met eigen scrollbalk (bundelbouwer) ---------- */
(function () {
  function sync(r) {
    var t = r.parentNode.querySelector(".yb-bb__track span"); if (!t) return;
    var max = r.scrollWidth - r.clientWidth, w = r.clientWidth / Math.max(1, r.scrollWidth);
    t.parentNode.hidden = max <= 1;
    t.style.width = (w * 100) + "%";
    t.style.transform = "translateX(" + (max > 0 ? r.scrollLeft / max * (1 / w - 1) * 100 : 0) + "%)";
  }
  document.addEventListener("DOMContentLoaded", function () {
    Array.prototype.forEach.call(document.querySelectorAll("[data-yb-rail]"), function (r) {
      r.addEventListener("scroll", function () { sync(r); }, { passive: true });
      addEventListener("resize", function () { sync(r); });
      new MutationObserver(function () { sync(r); }).observe(r, { childList: true, subtree: true, attributes: true, attributeFilter: ["hidden"] });
      setTimeout(function () { sync(r); }, 60);
      var track = r.parentNode.querySelector(".yb-bb__track");
      if (track) track.addEventListener("click", function (e) { var b = track.getBoundingClientRect(); r.scrollTo({ left: (e.clientX - b.left) / b.width * r.scrollWidth - r.clientWidth / 2, behavior: "smooth" }); });
    });
    document.addEventListener("click", function (e) {
      var b = e.target.closest("[data-rail-scroll]"); if (!b) return;
      var r = document.getElementById(b.dataset.railScroll); if (!r) return;
      r.scrollBy({ left: +b.dataset.dir * r.clientWidth * 0.8, behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
    });
  });
})();

/* ---------- Productaanbevelingen (Shopify Product Recommendations API) ---------- */
(function () {
  function load() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-yb-recs][data-url]"), function (el) {
      if (el.dataset.loaded) return; el.dataset.loaded = "1";
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement("div"); d.innerHTML = html;
        var n = d.querySelector("[data-yb-recs]"); if (n && n.innerHTML.trim()) el.innerHTML = n.innerHTML;
      }).catch(function () {});
    });
  }
  document.addEventListener("DOMContentLoaded", load);
  document.addEventListener("yb:cart-updated", load);
})();

/* ---------- Verlanglijstje-pagina ---------- */
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    var el = document.querySelector("[data-yb-wishlist]"); if (!el) return;
    var list; try { list = JSON.parse(localStorage.getItem("yb-wish") || "[]"); } catch (e) { list = []; }
    var empty = el.querySelector("[data-wish-empty]"), grid = el.querySelector("[data-wish-grid]");
    if (!list.length) { empty.hidden = false; return; }
    var root = (window.YB_CFG && YB_CFG.routes && YB_CFG.routes.root) || "/";
    Promise.all(list.map(function (h) {
      return fetch(root.replace(/\/$/, "") + "/products/" + encodeURIComponent(h) + "?view=card").then(function (r) { return r.ok ? r.text() : ""; }).catch(function () { return ""; });
    })).then(function (cards) {
      var html = cards.filter(Boolean).map(function (c) { return "<li>" + c + "</li>"; }).join("");
      if (!html) { empty.hidden = false; return; }
      grid.innerHTML = html;
      document.dispatchEvent(new CustomEvent("yb:cart-updated"));
    });
  });
})();
